/**
 * @file Initilizing options for cytoscape.js-edge-editing extension, which is used for reconnecting and
 *    adding bend points and control points.
 */

// @ts-nocheck
export const eeDefaults = {
  anchorShapeSizeFactor: 5,
  handleReconnectEdge: false,
  handleAnchors: false,
  enableCreateAnchorOnDrag: false,
};
